module.exports = __webpack_public_path__ + "assets/858ca5c42e68c828c2290936eb746b78.svg";